import React, { type FC } from 'react';
import type { Props } from 'reactApp/ui/ReactViewer/VideoPlayer/VideoPlayerComponent.type';

const VideoPlayerComponent = React.lazy(() => import(/* webpackChunkName: "VideoPlayer" */ './VideoPlayerComponent'));

// При переходе на другой элемент в архиве videojs делает dispose и удаляет <video из ДОМ,
// это создает проблему с videoRef при повторном переключении на этот же файл
// Поэтому сделана эта обертка с key, чтобы целиком удалять из ДОМ всё и заново рендерить вместе с новым <video
export const VideoPlayer: FC<Props> = (props) => {
    const { name, ...rest } = props;

    return <VideoPlayerComponent key={encodeURIComponent(name)} {...rest} name={name} />;
};
